var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddround(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: ""
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#008DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.999H10.5V13.499C10.5 13.6316 10.4473 13.7588 10.3536 13.8526C10.2598 13.9463 10.1326 13.999 10 13.999C9.86739 13.999 9.74021 13.9463 9.64645 13.8526C9.55268 13.7588 9.5 13.6316 9.5 13.499V10.999H7C6.86739 10.999 6.74021 10.9463 6.64645 10.8526C6.55268 10.7588 6.5 10.6316 6.5 10.499C6.5 10.3664 6.55268 10.2392 6.64645 10.1455C6.74021 10.0517 6.86739 9.99902 7 9.99902H9.5V7.49902C9.5 7.36642 9.55268 7.23924 9.64645 7.14547C9.74021 7.0517 9.86739 6.99902 10 6.99902C10.1326 6.99902 10.2598 7.0517 10.3536 7.14547C10.4473 7.23924 10.5 7.36642 10.5 7.49902V9.99902H13C13.1326 9.99902 13.2598 10.0517 13.3536 10.1455C13.4473 10.2392 13.5 10.3664 13.5 10.499C13.5 10.6316 13.4473 10.7588 13.3536 10.8526C13.2598 10.9463 13.1326 10.999 13 10.999Z",
    fill: "#008DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddround);
export default __webpack_public_path__ + "static/media/addround.d2f38c21f3df24ee1d058a76a56b876e.svg";
export { ForwardRef as ReactComponent };